// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';

import { HighChartOptions } from 'wdna-highchart';

const layout: any = _.get(window.store.getState(), ['layout']);

const pressets: HighChartOptions = {
  title: {
    style: {
      color: _.get(layout, 'skin.style.fontColor', 'red'),
    },
  },
  subtitle: {
    style: {
      color: _.get(layout, 'skin.style.fontColor', 'red'),
    },
  },
  chart: {
    type: 'column',
    zoomType: 'xy',
    height: '350px',
    backgroundColor: undefined,
    resetZoomButton: {
      position: {
        x: -30,
        y: -40,
      },
    },
  },
  tooltip: {
    shared: true,
    // crosshairs: true,
  },
  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
  },
  xAxis: [
    {
      title: {
        text: null,
      },
      type: 'category',
      labels: {
        format: '{value}',
        rotation: -60,
        style: {
          color: _.get(layout, 'skin.style.fontColor', 'red'),
        },
      },
      tickAmount: undefined,
      gridLineWidth: 0.1,
      crosshair: false,
    },
  ],
  yAxis: [
    {
      title: {
        text: null,
      },
      labels: {
        style: {
          color: _.get(layout, 'skin.style.leftAxisColor', 'red'),
        },
      },
      gridLineColor: _.get(layout, 'skin.style.leftAxisColor', 'red'),
      crosshair: false,
      tickAmount: 5,
      plotLines: undefined,
    },
    {
      title: {
        text: undefined,
      },
      labels: {
        style: {
          color: _.get(layout, 'skin.style.rightAxisColor', 'red'),
        },
      },
      gridLineColor: _.get(layout, 'skin.style.leftAxisColor', 'red'),
      crosshair: false,
      tickAmount: 5,
      plotLines: undefined,
      opposite: true,
    },
  ],
  plotOptions: {
    series: {
      cursor: 'pointer',
      borderWidth: 1,
      marker: {
        lineWidth: 1,
      },
    },
    line: {
      enableMouseTracking: false,
      allowPointSelect: false,
      marker: {
        enabled: false,
      },
      zIndex: -1,
    },
  },
  lang: {
    noData: 'NO UNLOADS.',
  },
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '15px',
      color: _.get(layout, 'skin.style.fontColor', 'red'),
    },
  },
  series: [],
  exporting: {
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        y: -20,
        theme: {
          stroke: undefined,
        },
      },
    },
  },
};

export default pressets;
